import axios from "./axios";
import { AxiosReturn } from "./types";
import * as Requests from "./requests";
import { IBranch } from "../types/shared";
import { BranchScheduledServicesPayload } from "../helpers/audit/utils";

export interface IEditBranchData {
  id: string;
  [key: string]: any;
  scheduled_services?: BranchScheduledServicesPayload;
}

export const editBranch = (token: string, data: IEditBranchData): AxiosReturn<IBranch> => {
  return axios.put(Requests.brancheByID(data.id), data, {
    headers: {
      token,
    },
  });
};
